import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { apiUrl } from '../utils/apiBase';

const DebugPropertyReportPage = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  
  const [debugInfo, setDebugInfo] = useState('Loading...');

  useEffect(() => {
    console.log('DebugPropertyReportPage: useEffect running');
    console.log('isAuthenticated:', isAuthenticated);
    console.log('user:', user);
    
    if (!isAuthenticated) {
      setDebugInfo('Not authenticated - redirecting to login');
      navigate('/login', { state: { role: 'land_reporter' } });
      return;
    }
    
    if (user?.role !== 'land_reporter') {
      setDebugInfo(`Wrong role: ${user?.role} - redirecting to login`);
      navigate('/login', { state: { role: 'land_reporter' } });
      return;
    }
    
    setDebugInfo('All checks passed - rendering page');
  }, [isAuthenticated, user, navigate]);

  if (!isAuthenticated || user?.role !== 'land_reporter') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Debug Info</h1>
          <p className="text-gray-600">{debugInfo}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Debug Property Report Page</h1>
        
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Debug Information</h2>
          <div className="space-y-2">
            <p><strong>Authenticated:</strong> {isAuthenticated ? 'Yes' : 'No'}</p>
            <p><strong>User Role:</strong> {user?.role || 'None'}</p>
            <p><strong>User Email:</strong> {user?.email || 'None'}</p>
            <p><strong>User ID:</strong> {user?.id || 'None'}</p>
            <p><strong>Debug Info:</strong> {debugInfo}</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Test API Connection</h2>
          <button 
            onClick={async () => {
              try {
                const token = localStorage.getItem('token');
                const response = await fetch(apiUrl('/properties/check-nearby'), {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                  },
                  body: JSON.stringify({
                    latitude: 40.7128,
                    longitude: -74.0060,
                    radius: 50
                  }),
                });
                
                const data = await response.json();
                console.log('API Response:', data);
                alert('API Test: ' + JSON.stringify(data, null, 2));
              } catch (error) {
                console.error('API Error:', error);
                alert('API Error: ' + error.message);
              }
            }}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Test Nearby Properties API
          </button>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Next Steps</h2>
          <p className="text-gray-600 mb-4">
            If this page loads correctly, the issue might be with the original PropertyReportPage components.
          </p>
          <button 
            onClick={() => navigate('/report')}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            Try Original Property Report Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default DebugPropertyReportPage;



